import React from "react";
import profile from "../../assets/uicon.png";
import "../../css/homepage.css";
const SearchUserItem = ({companies}) => {
  return (
    <div className="bg-[#434242] text-white py-2 my-1 text-xs space-x-2 rounded-sm px-4 grid grid-cols-12 leftboxes">
      <div className=" col-span-2">
        {companies?.businessLogoUrl ? (
          <>
            <img
              src={companies?.businessLogoUrl}
              alt="profile"
              className="w-11 h-11 rounded-sm"
            />
          </>
        ) : (
          <img src={profile} alt="profile" className="w-11 h-11 rounded-sm" />
        )}
      </div>
      <p className="lg:col-span-2  col-span-4 truncate self-center">
        {companies?.name}
      </p>
      <p className="col-span-2 truncate self-center hidden lg:block">
        {companies?.address}
      </p>
    </div>
  );
};

export default SearchUserItem;
